
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"16 16 96 96"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M99.292 88.384c-13.757-3.176-26.561-5.96-20.36-17.672C97.811 35.064 83.934 16 64.001 16c-20.328 0-33.856 19.796-14.928 54.712 6.388 11.78-6.9 14.564-20.36 17.672C16.42 91.224 15.96 97.328 16 108l.016 4h95.963l.016-3.876c.048-10.752-.368-16.888-12.704-19.74z","fill":"#3F51B5"}})])
          )
        }
      }
    